enum MksActionTypesEnum {
  SAVE_CYLINDERS = 'SAVE_CYLINDERS',
  SET_SELECTED_CYLINDER = 'SET_SELECTED_CYLINDER',
  SAVE_KEYS = 'SAVE_KEYS',
  SET_SELECTED_KEY = 'SET_SELECTED_KEY',
  SET_SELECTED_HOSTNAME = 'SET_SELECTED_HOSTNAME',
  SET_SELECTED_DOMAIN = 'SET_SELECTED_DOMAIN',
  SAVE_IMPORTS = 'SAVE_IMPORTS',
  SET_SELECTED_IMPORT = 'SET_SELECTED_IMPORT',
  SAVE_LAST_IMPORT = 'SAVE_LAST_IMPORT',
  SAVE_CSV_PREVIEW = 'SAVE_CSV_PREVIEW',
  CLEAR_CSV_PREVIEW = 'CLEAR_CSV_PREVIEW',
  SAVE_RELATIONS = 'SAVE_RELATIONS',
  RESET_MKS_DATA = 'RESET_MKS_DATA',
  SAVE_MKS_REQUESTS = 'SAVE_MKS_REQUESTS',
  SET_SELECTED_MKS_REQUEST = 'SET_SELECTED_MKS_REQUEST',
  SAVE_MKS_REQUEST_DETAIL = 'SAVE_MKS_REQUEST_DETAIL',
  UPDATE_MKS_REQUEST = 'UPDATE_MKS_REQUEST',
  DELETE_MKS_REQUEST = 'DELETE_MKS_REQUEST',
  CHANGE_MKS_REQUEST_STATUS = 'CHANGE_MKS_REQUEST_STATUS',
  EXPORT_MKS_REQUESTS = 'EXPORT_MKS_REQUESTS',
  RESET_MKS_REQUESTS_DATA = 'RESET_MKS_REQUESTS_DATA',
  RESET_MKS_CYLINDERS_DATA = 'RESET_MKS_CYLINDERS_DATA',
  RESET_MKS_KEYS_DATA = 'RESET_MKS_KEYS_DATA',
  RESET_MKS_RELATIONS_DATA = 'RESET_MKS_RELATIONS_DATA',
  RESET_MKS_IMPORTS_DATA = 'RESET_MKS_IMPORTS_DATA',
}

export default MksActionTypesEnum;
